var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "modal",
      attrs: {
        close: _vm.close,
        printButton: "",
        downloadButton: "",
        printStyle: _vm.printStyle,
        title: _vm.title,
      },
    },
    [
      _c(
        "h3",
        {
          staticClass: "modal__header",
          attrs: { slot: "modalHeader" },
          slot: "modalHeader",
        },
        [
          _c("i", { staticClass: "uk-icon-users" }),
          _vm._v("\n        Сообщения эмитента\n    "),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal__content",
          attrs: { slot: "modalBody" },
          slot: "modalBody",
        },
        [
          _vm.isLoading ? _c("loading") : _vm._e(),
          _vm._v(" "),
          !_vm.isLoading && !_vm.list.length
            ? _c("issuer-not-found")
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLoading && _vm.list.length
            ? _c(
                "ul",
                { staticClass: "list" },
                _vm._l(_vm.list, function (e, i) {
                  return _c(
                    "li",
                    { key: i, staticClass: "list__item" },
                    [
                      _c("app-accordion", [
                        _c(
                          "p",
                          {
                            staticClass: "title",
                            attrs: { slot: "title" },
                            slot: "title",
                          },
                          [
                            e.date_event
                              ? _c("b", { staticClass: "title__date" }, [
                                  _vm._v(_vm._s(_vm.dateParser(e.date_event))),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            e.name_event
                              ? _c("span", { staticClass: "title__name" }, [
                                  _vm._v(_vm._s(e.name_event)),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            e.text_event
                              ? _c("pre", { staticClass: "text" }, [
                                  _vm._v(_vm._s(e.text_event)),
                                ])
                              : _c("pre", { staticClass: "text no_print" }, [
                                  _vm._v(
                                    "Не удалось загрузить текст. Попробуйте загрузить позже."
                                  ),
                                ]),
                          ]
                        ),
                      ]),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal__footer",
          attrs: { slot: "modalFooter" },
          slot: "modalFooter",
        },
        [
          _vm.pagination && _vm.pagination.rows_count > 25
            ? _c("old-pagination", {
                attrs: {
                  paginationObj: _vm.pagination,
                  getNewContent: _vm.changePage,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }